import { render, staticRenderFns } from "./Catalog.vue?vue&type=template&id=8a1b7aa8&scoped=true&"
import script from "./Catalog.vue?vue&type=script&lang=js&"
export * from "./Catalog.vue?vue&type=script&lang=js&"
import style0 from "./Catalog.vue?vue&type=style&index=0&lang=scss&"
import style1 from "./Catalog.vue?vue&type=style&index=1&id=8a1b7aa8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8a1b7aa8",
  null
  
)

export default component.exports